/**
 * Calculates the total excess dead air time above a given threshold.
 * For each interval exceeding the threshold, only the portion above the threshold is summed.
 * Example: threshold=3000, intervals=[2000, 4000, 5000] => (4000-3000) + (5000-3000) = 3000
 */
export function calcExcessDeadAirAboveThreshold(intervals: number[], thresholdMs: number): number {
	return intervals
		.filter((interval) => interval > thresholdMs)
		.reduce((sum, interval) => sum + (interval - thresholdMs), 0);
}
